import React, { FC, memo } from "react";
import { createUseStyles } from "react-jss";

import ArrowLeft from "Assets/images/left_arrow.svg";
import { areEqualShallow } from "Utils/areEqual";
import styles from "./styles";

interface Props {
  onClick: (e: any) => void;
  className?: string;
}
const LeftArrow: FC<Props> = memo(({ onClick, className = "" }: Props) => {
  const classes = createUseStyles(styles)();
  const click = (e: any) => {
    e.preventDefault();
    if (onClick) onClick(e);
  };
  return (
    <ArrowLeft
      id="arrowLeftIcon"
      className={`${classes.pointer} ${className}`}
      onClick={click}
    />
  );
}, areEqualShallow);
LeftArrow.defaultProps = {
  className: undefined,
};
export default LeftArrow;
